export default __webpack_public_path__ + "static/media/shendoh_of_the_whispering_blade.00561117.jpg";